<template>
  <div class="backstage-card" :style="{ height }">
    <div v-if="videoUrl || imageUrl" class="backstage-card__media" @contextmenu.prevent>
      <BackstageVideo v-if="videoUrl" :src="videoUrl" :poster="thumbnailUrl" class="backstage-card__video" />
      <!-- Regular image (no video) -->
      <BackstageImage v-else-if="imageUrl" :src="imageUrl" :alt="title ?? 'Image'" class="backstage-card__image" />
    </div>

    <div class="backstage-card__content">
      <h2 v-if="title" class="backstage-card__title">{{ title }}</h2>

      <p v-if="description" class="backstage-card__description">{{ description }}</p>

      <div v-if="date || duration" class="backstage-card__meta">
        <span v-if="date">{{ date }}</span>
        <span v-if="date && duration" class="backstage-card__separator">·</span>
        <span v-if="duration">{{ duration }} {{ duration > 1 ? $t('viewFaqs.minutes') : $t('viewFaqs.minute') }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import BackstageImage from '@/components/common/BackstageImage.vue';
import BackstageVideo from '@/components/common/BackstageVideo.vue';

defineProps<{
  height?: string;
  videoUrl?: string;
  thumbnailUrl?: string;
  imageUrl?: string;
  title?: string;
  description?: string;
  date?: string;
  duration?: number;
}>();
</script>

<style lang="scss" scoped>
.backstage-card {
  background: var(--primary-bg-color);
  padding: 40px;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;

  &__media {
    position: relative;
    aspect-ratio: 16 / 9;
    overflow: hidden;
    flex-shrink: 0;
    margin-bottom: 16px;
  }

  &__video,
  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    user-select: none;
    -webkit-user-select: none;
    pointer-events: auto;
  }

  &__content {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  &__title {
    font-size: 20px;
    font-weight: 700;
    margin: 0 0 8px 0;
    line-height: 1.3;
    text-align: left;
    color: var(--primary-text-color);
  }

  &__description {
    font-size: 20px;
    color: var(--primary-text-color);
    line-height: 150%;
    overflow: hidden;
    text-align: left;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    line-clamp: 4;
    -webkit-box-orient: vertical;
    margin: 0;
  }

  &__meta {
    font-size: 16px;
    color: var(--dark-gray-color);
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: auto;
    padding-top: 1rem;
  }

  &__separator {
    font-size: 0.5rem;
  }
}
</style>
